const contentQnAPrefix = 'contentqna-';

export const analyticsIds = {
	summarization: {
		generateSummaryButton: `${contentQnAPrefix}generateSummaryButton`,
		copySummaryButton: `${contentQnAPrefix}copySummaryButton`,
		regenerateSummaryButton: `${contentQnAPrefix}regenerateSummaryButton`,
		citationButton: `${contentQnAPrefix}openSummaryCitationButton`,
		cancelSummaryButton: `${contentQnAPrefix}cancelSummaryButton`,
		feedbackLikeButton: `${contentQnAPrefix}summarizationFeedbackLikeButton`,
		feedbackDislikeButton: `${contentQnAPrefix}summarizationFeedbackDislikeButton`,
	},
	aiAssistant: {
		openAIAssistantButton: `${contentQnAPrefix}openAIAssistant`,
		clearChatButton: `${contentQnAPrefix}clearChat`,
		copyResponseButton: `${contentQnAPrefix}copyResponseButton`,
		feedbackLikeButton: `${contentQnAPrefix}assistantFeedbackLikeButton`,
		feedbackDislikeButton: `${contentQnAPrefix}assistantFeedbackDislikeButton`,
		regenerateResponseButton: `${contentQnAPrefix}regenerateResponseButton`,
		promptButton: `${contentQnAPrefix}promptButton`,
		citationButton: `${contentQnAPrefix}openCitationButton`,
		submitQuestion: `${contentQnAPrefix}submitQuestion`,
	},
};

interface Window {
	pendo?: any;
}

export function sendPendoTrackEvent(event: string, metadata: any = {}) {
	try {
		const pendo = (window as unknown as Window)?.pendo;
		if (!pendo?.track) {
			return;
		}
		const metadataWithProductName = {
			...metadata,
			product: 'ShareFile - Content QnA',
			type: event,
		};
		pendo.track(event, metadataWithProductName);
	} catch {}
}
